import React, { FC } from 'react';
import { Card, CardBody } from 'reactstrap';
import { Device } from '../../shared/device';
import { useTranslation } from '../translations';
import { MaterialIcon } from './MaterialIcon';
import './Device.scss';

interface DeviceProps {
  readonly device: Device;
}

export const DeviceListItem: FC<DeviceProps> = ({ device }) => {
  const { ts } = useTranslation();
  return (
    <Card className="device-item">
      <CardBody className="device-item-body">
        <div className="device-icon">
          <MaterialIcon
            medium
            name={device.make.toLowerCase().includes('apple') ? 'phone_iphone' : 'phone_android'}
          />
        </div>
        <div className="device-info">
          <div className="device-identifiers main-col">
            <div className="device-id-main">{device.id}</div>
            <div className="device-id">{ts('device_id_deviceidentifier', device.identifier)}</div>
          </div>
          <div className="device-metadata">
            <div>{ts('running_quikticket')}</div>
            <div className="device-makemodel">
              {ts(
                'devicemake_devicemodel_deviceosversion',
                device.make,
                device.model,
                device.osVersion,
              )}
            </div>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};
